<template>
  <!-- app广告 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <el-form-item :label="$t('pages.system.text30')">
          <el-input
            v-model="searchParams.adName"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text31')">
          <el-date-picker
            v-model="searchParams.startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            @change="startChange"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
          <span style="margin: 0 14px">-</span>
          <el-date-picker
            v-model="searchParams.stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="search"
          v-permission="['appAdvertising:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['appAdvertising:reset']"
        ></DiluButton>
      </div>
    </div>

    <!-- 按钮区域 -->
    <div class="operation">
      <DiluButton
        type="add"
        @click="add"
        v-permission="['appAdvertising:add']"
      ></DiluButton>
      <DiluButton
        v-permission="['appAdvertising:remove']"
        type="delete"
        v-if="selectIds.length > 0"
        @click="remove"
      ></DiluButton>
    </div>

    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :total="total"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
      @handleSelectionChange="handleSelectionChange"
    >
      <el-table-column type="selection" width="40"></el-table-column>
      <el-table-column prop="date" label="#" width="40" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="functionCode"
        :label="$t('pages.system.text32')"
        width="200"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="adName"
        :label="$t('pages.system.text30')"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="startAt"
        :label="$t('pages.system.text31')"
        align="center"
        width="310"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.validStartTime }}</span
          ><label for="" style="margin: 0 5px">-</label
          ><span>{{ scope.row.validStopTime }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('pages.system.text33')"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <el-image
            :src="scope.row.appAdAndUrl.imagePath"
            class="elimg"
            style="width: 120px"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('pages.system.text34')"
        width="220"
        align="center"
      >
        <template slot-scope="scope">
          <a :href="scope.row.appAdAndUrl.linkUrl" target="_blank">{{
            scope.row.appAdAndUrl.linkUrl
          }}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdBy"
        :label="$t('pages.system.text6')"
        width="100"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        :label="$t('pages.system.text3')"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button
              @click="see(scope.row)"
              type="text"
              v-permission="['appAdvertising:see']"
              >{{ $t("button.look") }}</el-button
            >
            <el-button
              @click="edit(scope.row)"
              type="text"
              v-permission="['appAdvertising:edit']"
              >{{ $t("button.edit") }}</el-button
            >
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 新增弹窗 -->
    <AppAdvertisementAddModule
      @dialogClose="dialogClose"
      :dialogVisible="dialogVisible"
      @appAdvertisingList="appAdvertisingList"
      :dialogStatus="dialogStatus"
      :currentAdvertising="currentAdvertising"
    />
  </div>
</template>

<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import AppAdvertisementAddModule from "./module/appAdvertisementAddModule.vue";
import { resetDate } from "../../../utils/util/validate";
import { mapState } from "vuex";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.searchParams.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      currentAdvertising: {}, //当前广告
      dialogStatus: 0, // 0新增 1编辑 2查看
      searchParams: {
        belongCustomerId: "", //
        adName: "", //广告名称
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        startAt: "", //开始生效时间
        stopAt: "", //结束生效时间
      },
      dialogVisible: false, //新增编辑弹窗
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      total: 0,
      tableData: [],
      selectIds: [],
      isSerch: false, //是否在查询
    };
  },
  components: {
    DiluTable,
    DiluButton,
    AppAdvertisementAddModule,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {
    this.appAdvertisingList();
  },
  methods: {
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.appAdvertisingList();
    },
    startChange() {
      this.searchParams.stopAt = null;
    },
    //选中触发
    handleSelectionChange(e) {
      this.selectIds = e.map((item) => {
        return item.id;
      });
    },
    //关闭新增编辑弹窗
    dialogClose() {
      this.dialogVisible = false;
    },
    //新增
    add() {
      this.dialogStatus = 0;
      this.dialogVisible = true;
    },
    //查看
    see(e) {
      this.dialogStatus = 2;
      this.currentAdvertising = e;
      this.dialogVisible = true;
    },
    //编辑
    edit(e) {
      this.dialogStatus = 1;
      this.currentAdvertising = e;
      this.dialogVisible = true;
    },
    //翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams = {
          belongCustomerId: "", //
          adName: "", //广告名称
          pageNum: 1, //页码
          pageSize: 10, //每页条数
          stopAt: "", //结束生效时间
          startAt: "", //开始生效时间
        };
      }
      this.searchParams.pageNum = e;
      this.appAdvertisingList();
    },
    //重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams = {
        belongCustomerId: "", //
        adName: "", //广告名称
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        stopAt: "", //结束生效时间
        startAt: "", //开始生效时间
      };
      this.total = 0;
      this.appAdvertisingList();
    },
    //批量删除
    remove() {
      this.$confirm(this.$t("pages.system.text35"), this.$t("public.text6"), {
        confirmButtonText: this.$t("button.determine"),
        cancelButtonText: this.$t("button.cancel"),
        type: "warning",
      })
        .then(() => {
          let arr = this.selectIds;
          this.request.appAdvertisingDelete({ ids: arr }).then(() => {
            this.total = 0;
            this.searchParams.pageNum = 1;
            this.$message.success(this.$t("public.text7"));
            this.appAdvertisingList();
          });
        })
        .catch(() => {});
    },
    //请求列表
    appAdvertisingList() {
      this.searchParams.belongCustomerId = "" + this.platformData.id;
      if (this.searchParams.startAt) {
        if (!this.searchParams.stopAt) {
          return this.$message.error(this.$t("public.text3"));
        }
      }
      if (this.searchParams.stopAt) {
        if (!this.searchParams.startAt) {
          return this.$message.error(this.$t("public.text2"));
        }
      }
      if (this.searchParams.stopAt && this.searchParams.startAt) {
        this.searchParams.stopAt = resetDate(this.searchParams.stopAt); // 结束时间
        this.searchParams.startAt = resetDate(this.searchParams.startAt); // 开始时间
      }
      this.request.appAdvertisingList(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-slot i {
  font-size: 20px;
}
.images {
  width: 80px;
}
.images img {
  width: 100%;
}
/* .elimg {
  width: 100%;
} */
.el-table td.el-table__cell div {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>